import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export interface User {
    id: number;
    valnet_user: ValnetUser;
}
export interface ValnetUser {
    id: number;
    firstName: string;
    lastName: string;
    fullName: string;
    loginName: string;
    email: string;
    fullNameAndLogin: string;
    fullLegalName: string;
}
export class articleUserList_template extends vnTemplate {


    protected getTemplateHtml(): string {

        return `
                <div data-bind="visible: isVisible, attr: {id: uniqueIdentifier}">
                    <ul class="selected-user-list" data-bind="foreach: users" id="users">
                        <li class="selected-user-item " >
                            <span class="icon i-user" data-bind="attr:{id:id}, text: $data.valnet_user.fullNameAndLogin"></span>
                            <button type="button" data-bind="event: { click: $parent.onRemoveUser }" class="close-btn icon i-delete-a" id="user-input-remove"></button>
                        </li>
                    </ul>
                    
                </div>
                `;
    }

    protected getTemplateName(): string {

        return "articleUserList_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            users: ko.observableArray([]),
            userIds: ko.observableArray([]),
            isVisible: ko.observable(true),
            uniqueIdentifier: ko.observable('uniqueUsersList'),
            onRemoveUser: (data, event) => {
                self.onRemoveUser(event, data);
            }
        };
    }

    protected onChangeFilterAction(data) {

        this.caller.filterSimpleOnChange();
    }

    protected onRemoveUser(event: PointerEvent, data: User) {

        let users = this.getTemplateViewModel().users();
        let filtered = users.filter(u => u.id != data.id);
        this.getTemplateViewModel().users(filtered);
        this.updateUserIds();
    }

    public setIsVisible(isVisible){

        this.getTemplateViewModel().isVisible(isVisible);
    }

    public addUser(user: User) {

        let userIds = this.getTemplateViewModel().userIds();


        // add a user to the list only if the user is not already in the list.
        if (userIds.indexOf(user.id) === -1) {

            let displayUser = {
                id: user.id,
                valnet_user: {
                    firstName: user.valnet_user.firstName,
                    lastName: user.valnet_user.lastName,
                    fullName: user.valnet_user.fullName,
                    loginName: user.valnet_user.loginName,
                    email: user.valnet_user.email,
                    fullNameAndLogin: user.valnet_user.fullNameAndLogin,
                    fullLegalName: user.valnet_user.fullLegalName,
                }
            };

            let users = this.getTemplateViewModel().users();
            users.push(displayUser);

            this.getTemplateViewModel().users(users);
        }

        this.updateUserIds()
    }

   public setUsers(users?: Array<User>): void {

        if (users && users.length > 0) {
            this.getTemplateViewModel().isVisible(true);
        }
        this.getTemplateViewModel().users(users);
        this.updateUserIds();
   }

    public setUniqueIdentifier(identifier: string): void {

        this.getTemplateViewModel().uniqueIdentifier(identifier);
    }

    protected getUniqueIdentifier(): string {

        return this.getTemplateViewModel().uniqueIdentifier();
    }

    public updateUserIds(): void{

        let userIds = [];

        this.getTemplateViewModel().users().forEach((u) => userIds.push(u.id));

        this.getTemplateViewModel().userIds(userIds);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/articleUserList_template.ts